<template>
  <div>
    <FloatingMenu />
    <MenuBar />

    <div class="mobileOnly">
      <div id="aboutUsPage" v-if="this.langChosen === 'gr'">
        <transition enter-active-class="animated fadeIn" appear>
          <div class="aboutUsPageTitle">우리에 대해</div>
        </transition>

        <div class="heroImage" />

        <div class="contactContainer">
          <p>
            책임감있는 글로벌 게임 회사가되기 위해 노력합니다. 우리의 전문적인 행동과 공정하고 안전한 도박을 보장하기
            위해 비즈니스 행동은 최고 기준에 따라 취급되어야합니다. 고객 보호 경험
          </p>

          <p>
            우리 게임을 좋아하는 많은 사람들이 희롱이나 사회적 오락을 위해 게임을합니다. 그러나 우리는 그들을 과장 할
            수있는 소수의 사람들이있을 수 있음을 알고 있습니다. 결과적으로 우리는 모두를위한 책임감있는 게임 환경을
            만들기 위해 예방 조치를 취합니다.
          </p>

          <p>
            우리는 과도하고 무책임한 플레이를 조장하지 않는 방식으로 제품을 설계하고 전달합니다. 우리는 최소 판돈 금액이
            낮으며 다양한 스포츠 베팅을 제공합니다.
          </p>

          <p>
            우리는 책임감 있고 좋은 고객 서비스를 제공한다고 믿습니다. 우리는 고객에게 책임감있는 도박과 필요한 경우
            도움을받는 방법에 대해 사전에 교육하고 교육합니다.
          </p>
        </div>
      </div>

      <div id="aboutUsPage" v-else>
        <transition enter-active-class="animated fadeIn" appear>
          <div class="aboutUsPageTitle">About Us</div>
        </transition>

        <div class="heroImage" />

        <div class="contactContainer">
          <p>
            Busan Lotteries is committed to be a world-class responsible gaming company. Our professional conduct and
            business behaviours must be upheld to the very highest standards, ensuring a fair and safe gambling
            experience to protect our customers.
          </p>

          <p>
            Many who like our games play for just a little flutter or social recreation. However, we recognize there may
            be a minority who may play beyond their means. As such, we have safeguards in place to help create a
            responsible gaming environment for all.
          </p>

          <p>
            We design and communicate our products in a manner that will not promote excessive and irresponsible play.
            We have low minimum bet amounts and offer a conservative range of sports bets.
          </p>

          <p>
            We believe in delivering responsible and good customer service. We proactively inform and educate our
            customers to bet responsibly, and how to get help should they need it.
          </p>
        </div>
      </div>
    </div>

    <div id="aboutDesktop">
      <div class="heroHeader">
        <transition enter-active-class="animated fadeIn" appear>
          <div v-if="this.langChosen === 'gr'">회사 소개</div>
          <div v-else>About Us</div>
        </transition>
      </div>

      <div class="flex">
        <LeftBannerAds />

        <div class="aboutDesktopField">
          <div v-if="this.langChosen === 'gr'">
            <p>
              책임감있는 글로벌 게임 회사가되기 위해 노력합니다. 우리의 전문적인 행동과 비즈니스 행동은 고객을 보호하기
              위해 공정하고 안전한 도박 경험을 보장하기 위해 최고 기준에 따라 수행되어야합니다.
            </p>

            <p>
              우리 게임을 좋아하는 많은 사람들이 희롱이나 사회적 오락을 위해 게임을합니다. 그러나 우리는 그들을 과장 할
              수있는 소수의 사람들이있을 수 있음을 알고 있습니다. 결과적으로 우리는 모두를위한 책임감있는 게임 환경을
              만들기 위해 예방 조치를 취합니다.
            </p>

            <p>
              우리는 과도하고 무책임한 플레이를 조장하지 않는 방식으로 제품을 설계하고 전달합니다. 우리는 최소 판돈
              금액이 낮으며 다양한 스포츠 베팅을 제공합니다.
            </p>

            <p>
              우리는 책임감 있고 좋은 고객 서비스를 제공한다고 믿습니다. 우리는 고객에게 책임감있는 도박과 필요한 경우
              도움을받는 방법에 대해 사전에 교육하고 교육합니다.
            </p>
          </div>

          <div v-else>
            <p>
              Busan Lotteries is committed to being a world-class responsible gaming company. Our professional conduct
              and business behaviours must be upheld to the very highest standards, ensuring a fair and safe gambling
              experience to protect our customers.
            </p>

            <p>
              Many who like our games play for just a little flutter or social recreation. However, we recognize there
              may be a minority who may play beyond their means. As such, we have safeguards in place to help create a
              responsible gaming environment for all.
            </p>

            <p>
              We design and communicate our products in a manner that will not promote excessive and irresponsible play.
              We have low minimum bet amounts and offer a conservative range of sports bets.
            </p>

            <p>
              We believe in delivering responsible and good customer service. We proactively inform and educate our
              customers to bet responsibly, and how to get help should they need it.
            </p>
          </div>
        </div>

        <RightBannerAds />
      </div>
    </div>

    <FifthSection />
  </div>
</template>

<script>
import FloatingMenu from '../components/FloatingMenu';
import FifthSection from '../components/FifthSection';
import MenuBar from '../components/MenuBar';
import LeftBannerAds from '../components/LeftBannerAds';
import RightBannerAds from '../components/RightBannerAds';

export default {
  components: {
    FloatingMenu,
    FifthSection,
    MenuBar,
    LeftBannerAds,
    RightBannerAds,
  },

  mounted() {
    this.setDocTitle();
  },

  methods: {
    setDocTitle() {
      const langChosen = localStorage.getItem('langChosen');
      if (langChosen == 'gr') return (document.title = '우리에 대해 - 부산 복권');
      document.title = 'About Us - Busan Lotteries';
    },
  },
};
</script>

<style>
#aboutUsPage {
  background: url('../assets/backgroundFirstSection.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 100vw;
  padding: 5vw;
  padding-top: 3.75vh;
  box-sizing: border-box;
}

.aboutUsPageTitle {
  font-size: 165%;
  font-weight: bold;
  color: var(--lightColor);
  margin-bottom: 5.5vw;
}

#aboutUsPage .heroImage {
  height: 35vh;
  background: url('../assets/office-team.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 2vw 2vw 0 0;
  overflow: hidden;
}

.contactContainer {
  background-color: white;
  padding: 4vw;
  border-radius: 0 0 2vw 2vw;
  font-size: 0.98em;
}

.contactContainer p {
  margin: 0;
  margin-bottom: 3vw;
}

.contactContainer p:last-child {
  margin-bottom: 1vw;
}

#aboutDesktop {
  display: none;
}

@media screen and (min-width: 768px) {
  .mobileOnly {
    display: none;
  }

  #aboutDesktop {
    background-color: var(--darkColor);
    min-height: 100vh;
    display: block;
  }

  #aboutDesktop .heroHeader {
    background-image: url('../assets/office-team.jpg'),
      linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.6));
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-size: 6em;
    font-weight: bold;
    color: white;
    padding: 138px 0;
    background-position: center;
    text-shadow: 1px 1px 4px black;
  }

  .aboutDesktopField {
    line-height: 150%;
    font-size: 1.2em;
    width: 60%;
    margin: auto;
    height: 600px;
    overflow: scroll;
    background: var(--bluePrim-lighter-4);
    position: relative;
    top: -50px;
    padding: 15px 40px;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    margin-bottom: -50px;
  }

  #aboutDesktop .adsSpace1,
  #aboutDesktop .adsSpace2 {
    width: 18%;
    position: relative;
    z-index: 3;
    text-align: center;
    border-radius: 5px;
    top: -50px;
    margin-bottom: -50px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }
}
</style>
